// Zustand store that mirrors the AirborneState from airborneDetector.ts,
// making motion-mode readable as a reactive value in React components
// and Zustand selectors.
//
// The store subscribes once at module-load time via onAirborneChange;
// any downstream component that reads `useAirborneStore` will
// re-render automatically when the detector transitions state.

import { create } from 'zustand';
import {
  onAirborneChange,
  getAirborneState,
  type AirborneState,
} from '../lib/airborneDetector';

interface AirborneStoreState {
  state: AirborneState;
}

export const useAirborneStore = create<AirborneStoreState>((set) => {
  // Subscribe once at module load; fires immediately with current state.
  onAirborneChange((next) => set({ state: next }));
  return { state: getAirborneState() };
});
